import { mapOccurrencesToScheduledItems } from './projectedOccurrence'
import { projectInstrumentOccurrences } from './legacy/legacyOccurrenceProjection'

/**
 * Project all instruments to occurrences and scheduled grid items.
 * @param {object} context
 * @param {Array} context.instruments
 * @param {Array} [context.visits]
 * @param {Array} [context.armsForEngine]
 * @param {Set|null} [context.selectedArmVisitIds]
 * @param {boolean} [context.useAbsoluteStartDate]
 * @param {string|null} [context.absoluteStartDate]
 * @param {number|null} [context.studyEndDay]
 * @param {'template'|'participant'} [context.projectionMode]
 * @param {Array} [context.participantVisits]
 */
export const projectInstrumentSchedules = (context = {}) => {
  const { instruments = [] } = context
  const occurrences = projectInstrumentOccurrences(instruments, context)
  const items = mapOccurrencesToScheduledItems(occurrences, {
    useAbsoluteStartDate: context.useAbsoluteStartDate,
    absoluteStartDate: context.absoluteStartDate,
  })
  return { occurrences, items }
}
